import type { TagAppearance } from '@fourthwall/components'

import type { Status } from '../../../consts/status'

export const STATUSES: Record<Status, { label: string; appearance: TagAppearance }> = {
  // Order Statuses
  CONFIRMED: {
    label: 'Order placed',
    appearance: 'default',
  },
  COMPLETED: {
    label: 'Completed',
    appearance: 'success',
  },
  PARTIALLY_IN_PRODUCTION: {
    label: 'Partially in production',
    appearance: 'default',
  },
  IN_PRODUCTION: {
    label: 'In production',
    appearance: 'default',
  },
  PARTIALLY_SHIPPED: {
    label: 'Partially shipped',
    appearance: 'default',
  },
  SHIPPED: {
    label: 'Shipped',
    appearance: 'default',
  },
  PARTIALLY_DELIVERED: {
    label: 'Partially delivered',
    appearance: 'default',
  },
  DELIVERED: {
    label: 'Delivered',
    appearance: 'success',
  },
  CANCELLED: {
    label: 'Canceled',
    appearance: 'alert',
  },
  SCHEDULE: {
    label: 'Schedule',
    appearance: 'alert',
  },

  // ORDER - existing order statuses, but should never appear on frontend
  OPEN: {
    label: 'Awaiting payment',
    appearance: 'default',
  },
  ABANDONED: {
    label: 'Payment failed',
    appearance: 'default',
  },
  FAILED: {
    label: 'Failed',
    appearance: 'default',
  },

  // Product
  PUBLIC: {
    label: 'Public',
    appearance: 'success',
  },
  HIDDEN: {
    label: 'Hidden',
    appearance: 'alert',
  },
  ARCHIVED: {
    label: 'Archived',
    appearance: 'default',
  },

  // kudos
  WAITING: {
    label: 'Waiting',
    appearance: 'alert',
  },
  SENT: {
    label: 'Sent',
    appearance: 'success',
  },
}
